angular.module('pl-shared').filter('wrapEmail', function() {
  return function(email) {
    return (email || '').replace('@', '\u200B@')
  }
})
